import { Component, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent implements OnChanges, OnDestroy {
  @Input() active: boolean = false;
  @Input() customMessage: string = '';
  @Input() persistentMessage: boolean = false;
  @Input() showContinueButton: boolean = false;

  message: string = '';
  private timer5s: any = null;
  private timer10s: any = null;
  private timer15s: any = null;
  private startTime: number = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['active']) {
      if (this.active) {
        this.startTimers();
      } else {
        this.clearTimers();
        this.message = '';
      }
    }
  }

  ngOnDestroy(): void {
    this.clearTimers();
  }

  private startTimers(): void {
    this.startTime = Date.now();
    this.message = this.customMessage || '';

    // Limpa timers anteriores se existirem
    this.clearTimers();

    if (this.persistentMessage) {
      return;
    }

    // Mensagem após 5 segundos
    this.timer5s = setTimeout(() => {
      this.message = 'Aguarde...';
    }, 5000);

    // Mensagem após 15 segundos
    this.timer10s = setTimeout(() => {
      this.message = 'Só mais um momento...';
    }, 15000);

    // Mensagem após 30 segundos
    this.timer15s = setTimeout(() => {
      this.message = 'Isso pode demorar um pouco. Não feche está janela. Aguarde...';
    }, 30000);
  }

  private clearTimers(): void {
    if (this.timer5s) {
      clearTimeout(this.timer5s);
      this.timer5s = null;
    }
    if (this.timer10s) {
      clearTimeout(this.timer10s);
      this.timer10s = null;
    }
    if (this.timer15s) {
      clearTimeout(this.timer15s);
      this.timer15s = null;
    }
  }

  openNewTab(): void {
    const url = window.location.href;
    window.open(url, '_blank');
  }
}

